import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaApparatoGastroentericoEditComponent.vue?vue&type=template&id=36562a44"
import script from "./RsaSchedaRelazioneSanitariaApparatoGastroentericoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaApparatoGastroentericoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports